define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.moveToParams = void 0;

  var moveToParams = function moveToParams(service, params) {
    if (params === void 0) {
      params = {};
    }

    var location = window.location.pathname.split(/^./)[1];
    var paramsUrl = (location.length ? '&' : '?') + Object.keys(params).map(function (prop) {
      return [prop, params[prop]].map(encodeURIComponent).join('=');
    }).join('&');
    return "/move-to/" + service + (location.length ? (service.indexOf('?') > 0 ? '&' : '?') + 'url_params=' + location : '') + (Object.keys(params).length === 0 ? '' : paramsUrl);
  };

  _exports.moveToParams = moveToParams;
});